/**
 * The chrome-less dashboard print route (AB#6645), rendered by a headless
 * browser on a short-lived, read-only session.
 *
 * Read from `window.location` rather than router state on purpose: the API
 * layer and the app shell have to know it before any component has mounted,
 * because the very first requests already go out from child effects.
 */
export const DASHBOARD_PRINT_ROUTE = '/dashboards/:dashboardId/print'

/** Fired instead of the logout redirect when a print-route request is refused. */
export const PRINT_UNAUTHORIZED_EVENT = 'mbai:print-unauthorized'

export const isDashboardPrintPath = (
  pathname: string = typeof window === 'undefined' ? '' : window.location.pathname,
): boolean => /^\/dashboards\/[^/]+\/print\/?$/.test(pathname)

/**
 * The shop-floor display routes (AB#6756). A TV or tablet opens `/display`
 * without signing in, shows a pairing code, and once a dashboard editor has
 * approved it on `/display/pair` it shows that one dashboard at
 * `/display/:dashboardId` on its own, view-only screen credential.
 *
 * `/display/pair` is the approver's page: it runs on the person's session and
 * is not a display path for the API layer.
 */
export const DISPLAY_ROUTE = '/display'
export const DISPLAY_PAIR_ROUTE = '/display/pair'
export const DISPLAY_DASHBOARD_ROUTE = '/display/:dashboardId'

/** Fired instead of the logout redirect when the screen credential is refused. */
export const DISPLAY_UNAUTHORIZED_EVENT = 'mbai:display-unauthorized'

/** The screen side of the display routes: the pairing screen and the dashboard. */
export const isDisplayPath = (
  pathname: string = typeof window === 'undefined' ? '' : window.location.pathname,
): boolean => /^\/display(\/[^/]+)?\/?$/.test(pathname) && !isDisplayPairPath(pathname)

export const isDisplayPairPath = (
  pathname: string = typeof window === 'undefined' ? '' : window.location.pathname,
): boolean => /^\/display\/pair\/?$/.test(pathname)
